import { differenceInHours } from "date-fns";

export const getConnectionColor = (lastMessageTimestamp) => {
  if (
    !lastMessageTimestamp ||
    differenceInHours(new Date(), new Date(lastMessageTimestamp)) >= 24
  ) {
    return "red";
  } else if (
    differenceInHours(new Date(), new Date(lastMessageTimestamp)) >= 20
  ) {
    return "yellow";
  } else {
    return "green";
  }
};
